/* Granola Baby review pages: CTA click tracking, auto TOC, sticky mobile CTA */
(function(){
  function track(el){
    var d={brand:el.dataset.gbBrand||'',retailer:el.dataset.gbRetailer||'',position:el.dataset.gbPos||'',url:el.href,page:location.pathname};
    try{if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish){Shopify.analytics.publish('gb_affiliate_click',d);}}catch(e){}
    try{window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:'gb_affiliate_click'},d));}catch(e){}
    try{if(typeof window.gtag==='function'){gtag('event','affiliate_click',{brand:d.brand,retailer:d.retailer,position:d.position,page_path:d.page});}}catch(e){}
  }
  function h(e){var a=e.target.closest&&e.target.closest('[data-gb-cta]');if(a)track(a);}
  document.addEventListener('click',h,true);document.addEventListener('auxclick',h,true);
  function toc(){
    var box=document.querySelector('[data-gb-toc]');if(!box)return;
    var hs=[].slice.call(document.querySelectorAll('.gb [data-gb-h2]'));if(hs.length<3){box.remove();return;}
    var ol=box.querySelector('ol');hs.forEach(function(h){var li=document.createElement('li');var a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;li.appendChild(a);ol.appendChild(li);});
  }
  function sticky(){
    var bar=document.querySelector('[data-gb-sticky]'),hero=document.querySelector('.gb-hero');if(!bar||!hero||!('IntersectionObserver' in window))return;
    new IntersectionObserver(function(en){bar.classList.toggle('is-on',!en[0].isIntersecting);}).observe(hero);
  }
  if(document.readyState!=='loading'){toc();sticky();}else document.addEventListener('DOMContentLoaded',function(){toc();sticky();});
})();
